import { RFID_QR_CODE_MASK } from '../../../config/devices';

function removeLeadingZeros(hexString: string): string {
  const result = hexString.replace(/^0+/, '');
  return result.length > 0 ? result : '0';
}

export function parseRfidQRCode(decodedText: string): string | null {
  const match = RFID_QR_CODE_MASK.exec(decodedText.trim());
  if (match?.[1]) {
    return removeLeadingZeros(match[1].toUpperCase());
  }
  return null;
}
